import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import {
  backgroundColor,
  borderTop,
  boxShadow,
  color,
  display,
  flex,
  fontSize,
  gridGap,
  space,
  themeGet,
  width,
} from 'styled-system';

import { Button } from 'common/components/Button';
import { boxSizing } from 'common/theme/system-utilities';

interface DrawerFooterProps {
  label: string;
  isActive: boolean;
  isLoading: boolean;
  onClick: () => void;
  secondaryBtnOnClick?: () => void;
  secondaryBtnLabel?: string;
  ariaCtaLabel?: string;
}

const TRACKING_EVENT_NAME = 'common-disclaimer_click';

const UnstyledContainer = styled.div<any>`
  ${backgroundColor};
  ${boxSizing};
  ${color};
  ${display};
  ${space};
  ${width};
  ${borderTop};
  ${gridGap};
  ${boxShadow};
  box-shadow: 0 1px 8px 0 ${themeGet('colors.overlay')};
`;

const Container = (props: ComponentProps<typeof UnstyledContainer>) => (
  <UnstyledContainer
    backgroundColor="sys.neutral.background.default"
    boxSizing="border-box"
    borderTop={3}
    display="flex"
    pl={['sp_16', null, null, 'sp_20']}
    pr="sp_16"
    py="sp_8"
    width={1}
    {...props}
  />
);

const UnstyledProceedButton = styled(Button)<any>`
  ${fontSize};
  ${flex};
`;

const ProceedButton = (props: ComponentProps<typeof UnstyledProceedButton>) => (
  <UnstyledProceedButton fontSize="fs_16" flex="1" {...props} />
);

const Footer = ({
  label,
  isActive,
  isLoading,
  onClick,
  secondaryBtnLabel,
  secondaryBtnOnClick,
  ariaCtaLabel,
}: DrawerFooterProps) => (
  <Container {...(secondaryBtnLabel && secondaryBtnOnClick ? { gridGap: 'sp_8' } : {})}>
    {secondaryBtnLabel && secondaryBtnOnClick && (
      <ProceedButton isLoading={isLoading} onClick={secondaryBtnOnClick} kind="secondary">
        {secondaryBtnLabel}
      </ProceedButton>
    )}
    <ProceedButton
      disabled={!isActive || isLoading}
      isLoading={isLoading}
      onClick={onClick}
      tracking={{
        eventName: TRACKING_EVENT_NAME,
        text: label,
      }}
      {...(ariaCtaLabel ? { 'aria-label': ariaCtaLabel } : {})}
    >
      {label}
    </ProceedButton>
  </Container>
);

export default Footer;
